var map = {
	"./de.json": "ba16",
	"./en.json": "023c",
	"./fr.json": "3058",
	"./it.json": "512b",
	"./jp.json": "90c3",
	"./ko.json": "9a6f",
	"./mx.json": "1370",
	"./pt.json": "6249"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed5e";